import { render } from "./Notification.vue?vue&type=template&id=4f82a703"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=4f82a703&lang=scss"
script.render = render

export default script